import { AxiosError } from 'axios';
import { FC } from 'react';
import { showToast } from '../../../../components/Toast/Toast';
import { ToastTypes } from '../../../../components/Toast/Toast.types';
import { MENU_FILTERS } from '../../../../constants/ApiEnums';
import { useExtractMenu } from '../../../../services/extract/extract.service';
import { genericErrorShowToastOptions } from '../../../../utils/useGenericErrorMessage/useGenericErrorMessage';
import useNavigateWithToast from '../../../../utils/useNavigateWithToast/useNavigateWithToast';
import SelectMenus from '../SelectMenus/SelectMenus';
import { Organization } from '../../../../services/menu/menu.types';

const ExtractMenu: FC = () => {
  const navigateWithToast = useNavigateWithToast();

  const { mutate, isLoading } = useExtractMenu();

  const handleClick = (selectedMenus: Organization[]) => {
    mutate(
      selectedMenus.map((menu) => ({ menuNo: +menu.id, menuId: menu.additionalProperties.menuId })),
      {
        onSuccess: () => {
          navigateWithToast('/extract', {
            label: 'Menu extracts have been submitted. Please allow up to an hour for status to process.',
            id: 'menuExtractSuccess',
          });
        },
        onError: (error) => {
          if ((error as AxiosError).message === 'apiGatewayTimeout') return;
          showToast({
            ...genericErrorShowToastOptions,
            label: 'Error extracting menus.',
            id: 'menuExtractError',
            toastType: ToastTypes.Error,
          });
        },
      }
    );
  };

  return <SelectMenus activateOrExtract={MENU_FILTERS.EXTRACT} onClick={handleClick} isLoading={isLoading} />;
};

export default ExtractMenu;
